export default __webpack_public_path__ + "static/media/contacts_light.ed0eaac0.svg";